import { useQueryClient } from '@tanstack/react-query'
import { getListCustomLeadFormFields } from 'services/settings'
import { mapCustomLeadFormFields } from 'store/settings'
import { customFieldKey } from 'utils/constants/queryKey'

import { AppQueryOptions, useAppQueryMap } from './use-app-query'
import { STALE_TIME } from 'utils/constants'
import { GetListCustomLeadFormFieldPayload } from 'services/types/settings'

const useCustomLeadForm = (params?: GetListCustomLeadFormFieldPayload, options?: AppQueryOptions) => {
  const queryClient = useQueryClient()

  const list = useAppQueryMap(
    customFieldKey.list({ ...params }),
    () => getListCustomLeadFormFields(params || {}),
    mapCustomLeadFormFields,
    { ...options, staleTime: STALE_TIME.lookup },
  )

  return {
    ...list,
    invalidate: () => {
      queryClient.invalidateQueries(customFieldKey.list({ ...params }))
    },
  }
}

export default useCustomLeadForm
